// Generated by genversion.
export const version = '2.0.0-beta.12';
